
<template>
    <div>
        <topback title="Add Payment Method" path="back"></topback>
        <div class="addpaymentmethod">
            <md-field>
                <md-field-item title="Method" solid>
                    <md-radio name="bank" v-model="method" label="Bank" inline/>
                    <md-radio name="upi" v-model="method" label="UPI" inline />
                </md-field-item>
                <div v-if="method === 'bank'">
                    <paymentbankform :bank="bank" />
                </div>
                <div v-else>
                    <paymentupiform :bank="bank"/>
                </div>
                <md-field-item solid title="Notice">
                    <p slot="children" style="color: red;">
                        Please ensure that you fill in real personal information. The information you fill in will be used for real transactions. If there is a remittance error caused by incorrect information, TT will not accept it
                    </p>
                </md-field-item>
            </md-field>
        </div>
    </div>
</template>

<script>
import topback from '@/components/topback'
import paymentbankform from '@/views/my/forms/paymentbankform'
import paymentupiform from '@/views/my/forms/paymentupiform'
import { postpayment, getpayments } from '@/request/api'


export default {
    name: 'addpaymentmethod',
    components: {
		[topback.name]: topback,
        paymentbankform,
        paymentupiform
    },
    data() {
        return {
            method: 'bank',
            bank: {},
        }
    },
    created() {
        this.id = this.$route.params.id;
        if(this.id) {
            this.get_bankinfo(this.id);
        }
    },
    methods: {
        get_bankinfo(id) {
            getpayments({id: id}).then(res=>{
                if(res.code === 200) {
                    this.method = res.data.method;
                    this.bank = res.data;
                } else {
                    this.$toast.failed(res.errmsg);
                }
            })
        }
    }

}

</script>

<style scoped>
.addpaymentmethod {
    margin-top: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/paymentmethodadd.vue